import React from 'react';

const DnaIcon = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="42" strokeLinecap="round">
    <path d="M384 128c128 128 128 384 0 512S256 896 384 896"/>
    <path d="M640 128c-128 128-128 384 0 512s128 256 0 256"/>
    <path d="M384 256h256M384 512h256M384 768h256"/>
  </svg>
);

const PlasmidIcon = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="42">
    <circle cx="512" cy="512" r="384"/>
    <path d="M512 128v128M512 768v128M128 512h128M768 512h128" strokeLinecap="round"/>
  </svg>
);

const AntibodyIcon = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="42" strokeLinecap="round">
    <path d="M512 896V448M320 256l192 192 192-192"/>
  </svg>
);

const ProteinIcon = () => (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="42" strokeLinecap="round">
        <path d="M350 896h324L512 256 512 128"/>
        <path d="M448 128h128"/>
    </svg>
);

const StructureDesignIcon = () => (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="42" strokeLinecap="round">
        {/* Alpha helix - spiral structure */}
        <path d="M256 256c64-32 128 32 192 0s128-32 192 0 128 32 192 0"/>
        <path d="M256 384c64-32 128 32 192 0s128-32 192 0 128 32 192 0"/>
        <path d="M256 512c64-32 128 32 192 0s128-32 192 0 128 32 192 0"/>
        {/* Beta sheet - parallel lines with arrows */}
        <path d="M256 640h512M256 704h512M256 768h512"/>
        <path d="M704 640l64 32-64 32M704 704l64 32-64 32M704 768l64 32-64 32"/>
    </svg>
);

export const BioIcon = ({ type }: { type: string }) => {
  switch (type) {
    case 'dna':
      return <DnaIcon />;
    case 'plasmid':
      return <PlasmidIcon />;
    case 'antibody':
      return <AntibodyIcon />;
    case 'protein':
        return <ProteinIcon />;
    case 'structure':
        return <StructureDesignIcon />;
    default:
      return null;
  }
};
